import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
const ServiceReckoningFormStepOne = (props) => {
  const { t } = useTranslation();
  const SummaryBox = ({ title = "Usługi", netto = 0, brutto = 0, bold }) => {
    return (
      <Row>
        <Col xs={12} className="d-flex flex-column justify-content-center">
          <Row style={{ background: "#eeeec6" }} className="p-2 align-items-center">
            <Col xs={12} className="text-center mb-3">
              <div style={{ fontSize: "12px" }} className="text-muted small fw-bold">
                {title}
              </div>
            </Col>

            <Col xs={6}>
              <div className="text-muted small" >Netto</div>
              <div className={`${bold ? "fw-bold" : ""} text-muted`} >{netto}</div>
              <hr className="mt-0" />
            </Col>

            <Col xs={6}>
              <div className="text-muted small">Brutto</div>
              <div className={`${bold ? "fw-bold" : ""} text-muted`} >{brutto}</div>
              <hr className="mt-0" />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };
  return (
    <div style={{ justifyContent: "flex-start" }}>
      <Row>
        <Col xs={12}>
          <Field
            name="reckoningInternalSettlement"
            data-cy="reckoningInternalSettlement"
            component={BMXTextField}
            label={t("global:servicereckoning.reckoningInternalSettlement")}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Field
            name="reckoningExternalSettlement"
            data-cy="reckoningExternalSettlement"
            component={BMXTextField}
            label={t("global:servicereckoning.reckoningExternalSettlement")}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Field
            name="reckoningComments"
            data-cy="reckoningComments"
            component={BMXTextField}
            label={t("global:servicereckoning.reckoningComments")}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={2} className="d-flex flex-column justify-content-center mb-4">
          <SummaryBox
            title="Usługi"
            netto={240}
            brutto={240}
          />
        </Col>
        <Col xs={2} style={{ marginTop: "45px" }}>
          <Field
            name="serviceDiscount"
            data-cy="serviceDiscount"
            component={BMXTextField}
            label={t("global:servicereckoning.serviceDiscount")}
          />
        </Col>
        <Col xs={2} style={{ marginTop: "45px" }}>
          <Field
            name="serviceSupplement"
            data-cy="serviceSupplement"
            fieldtype={"checkbox"}
            component={BMXTextField}
            label={t("global:servicereckoning.serviceSupplement")}
          />
        </Col>
        <Col xs={2} className="d-flex flex-column justify-content-center mb-4">
          <SummaryBox
            title="Usługi po rabatach"
            netto={240}
            brutto={240}
          />
        </Col>

      </Row>
      <Row>
        <Col xs={2} className="d-flex flex-column justify-content-center  mb-4">
          <SummaryBox
            title="Części"
            netto={240}
            brutto={240}
          />
        </Col>
        <Col xs={2} style={{ marginTop: "45px" }}>
          <Field
            name="partsDiscount"
            data-cy="partsDiscount"
            component={BMXTextField}
            label={t("global:servicereckoning.partsDiscount")}
          />
        </Col>
        <Col xs={2} style={{ marginTop: "45px" }}>
          <Field
            name="partsSupplement"
            data-cy="partsSupplement"
            fieldtype={"checkbox"}
            component={BMXTextField}
            label={t("global:servicereckoning.partsSupplement")}
          />
        </Col>
        <Col xs={2} >
          <SummaryBox
            title="Części po rabatach"
            netto={240}
            brutto={240}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={2} >
          <SummaryBox
            title="Transport"
            netto={240}
            brutto={240}
          />
        </Col>
        <Col xs={2} style={{ marginTop: "45px" }}>
          <Field
            name="transportDiscount"
            data-cy="transportDiscount"
            component={BMXTextField}
            label={t("global:servicereckoning.transportDiscount")}
          />
        </Col>
        <Col xs={2} style={{ marginTop: "45px" }}>
          <Field
            name="transportSupplement"
            data-cy="transportSupplement"
            fieldtype={"checkbox"}
            component={BMXTextField}
            label={t("global:servicereckoning.transportSupplement")}
          />
        </Col>
        <Col xs={2} >
          <SummaryBox
            title="Transport po rabatach"
            netto={240}
            brutto={240}
          />
        </Col>
        <Col xs={{ span: 3, offset: 1 }}>
          <SummaryBox
            title="Łączny koszt obecnej interwencji"
            bold={true}
            netto={240}
            brutto={240}
          />
        </Col>
      </Row>

    </div >
  );
};

export default ServiceReckoningFormStepOne;
